export default __webpack_public_path__ + "592340780e23ddbac89ca745e3942e1b.png";